import { c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { theme, withProp } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import 'react';
import { oneOfType, number, string } from 'prop-types';
import { a as numberToPx } from './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import Box from './Box.js';
import '@emotion/is-prop-valid';
import s from 'styled-selector';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var CardFit = styled(Box)(_templateObject(), theme("CardFit"));
var CardFit$1 = use(CardFit, "div");

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n\n  && > *:not(", ") {\n    margin: ", ";\n  }\n\n  ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var Card = styled(Box)(_templateObject$1(), s(CardFit$1), withProp("gutter", numberToPx), theme("Card")); // @ts-ignore

Card.propTypes = {
  gutter: oneOfType([number, string])
};
Card.defaultProps = {
  gutter: "1rem",
  opaque: true,
  palette: "background",
  tone: -1
};
var Card$1 = use(Card, "div");

var index = Object.assign(Card$1, {
  Fit: CardFit$1
});

export default index;
